export default __webpack_public_path__ + "static/media/31.fa15aec8.png";